import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getPAPart,
  getPAPartExport,
  getPASupplier,
  updatePASupplierBuyerCode,
  type PAPartExportParam,
  type PAPartRequestParam,
  type PASupplierRequestParam,
} from "@/api/PAService";
import { CACHE_TIME } from "@/lib/cacheConfig";
import { queryKeys } from "@/lib/queryKeys";
import { useQueryInvalidation } from "@/lib/queryInvalidation";

export const useGetPAPart = (params: PAPartRequestParam) => {
  return useQuery({
    queryKey: queryKeys.pa.parts(params),
    queryFn: () => getPAPart(params),
    staleTime: CACHE_TIME.SHORT,
  });
};

export const useGetPASupplier = (params: PASupplierRequestParam) => {
  return useQuery({
    queryKey: queryKeys.pa.suppliers(params),
    queryFn: () => getPASupplier(params),
    staleTime: CACHE_TIME.SHORT,
  });
};

export const useExportPAPart = () => {
  return useMutation({
    mutationFn: (params: PAPartExportParam) => getPAPartExport(params),
  });
};

export const useUpdatePASupplierBuyerCode = () => {
  const queryInvalidation = useQueryInvalidation();

  return useMutation({
    mutationKey: queryKeys.pa.updateSupplierBuyerCode(),
    mutationFn: (params: { pa_supplier_id: number; buyer_code: string }) =>
      updatePASupplierBuyerCode(params.pa_supplier_id, params.buyer_code),
    onSuccess: () => {
      queryInvalidation.invalidatePAData();
    },
  });
};
